import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
}

export function formatNumber(value) {
  return new Intl.NumberFormat('fr-CA').format(value);
}

export function formatCompact(value) {
  const abs = Math.abs(value);
  if (abs >= 1e9) {
    return `${(value / 1e9).toFixed(2)}B $`;
  }
  if (abs >= 1e6) {
    return `${(value / 1e6).toFixed(2)}M $`;
  }
  if (abs >= 1e3) {
    return `${(value / 1e3).toFixed(1)}K $`;
  }
  return formatCurrency(value);
}

export function formatCompactMobile(value) {
  const abs = Math.abs(value);
  if (abs >= 1e9) return `${Math.round(value / 1e9)}B`;
  if (abs >= 1e6) return `${Math.round(value / 1e6)}M`;
  if (abs >= 1e3) return `${Math.round(value / 1e3)}K`;
  return `${Math.round(value)}`;
}
